import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const METHODS = { dinheiro: "Dinheiro", pix_estatico: "Pix por chave/QR fixo", pix_dinamico: "Pix por cobrança", credito: "Crédito", debito: "Débito" };

export default function PaymentFields({ payments, onChange, change, onChangeChange }) {
  const update = (index, patch) => onChange(payments.map((payment, i) => i === index ? { ...payment, ...patch, confirmado: false } : payment));
  return (
    <fieldset className="space-y-3 border-t border-border pt-3">
      <legend className="text-sm font-medium">Pagamentos</legend>
      <p className="text-xs text-muted-foreground">Registrar a forma de pagamento não confirma o recebimento.</p>
      {payments.map((payment, index) => (
        <div key={index} className="grid grid-cols-[1fr_6rem_auto] gap-2 items-end">
          <div>
            <Label htmlFor={`payment-method-${index}`} className="text-xs">Forma {index + 1}</Label>
            <Select value={payment.metodo} onValueChange={metodo => update(index, { metodo, tipo_integracao: undefined })}>
              <SelectTrigger id={`payment-method-${index}`} className="h-10 bg-input"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(METHODS).map(([value, label]) => <SelectItem key={value} value={value}>{label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor={`payment-value-${index}`} className="text-xs">Valor (R$)</Label>
            <Input id={`payment-value-${index}`} inputMode="decimal" value={payment.valor} onChange={e => update(index, { valor: e.target.value.replace(",", ".") })} />
          </div>
          <Button type="button" variant="ghost" aria-label={`Remover pagamento ${index + 1}`} disabled={payments.length === 1}
            onClick={() => onChange(payments.filter((_, i) => i !== index))}>×</Button>
          {["debito", "credito"].includes(payment.metodo) && <div className="col-span-3 space-y-1">
            <div className="flex items-start gap-2">
              <Checkbox id={`payment-pos-${index}`} checked={payment.tipo_integracao === "2"}
                onCheckedChange={checked => update(index, { tipo_integracao: checked === true ? "2" : undefined })} />
              <Label htmlFor={`payment-pos-${index}`} className="text-xs leading-4">{METHODS[payment.metodo]} em maquininha independente (POS)</Label>
            </div>
            <p className="text-xs text-muted-foreground">Confirme somente se o valor foi digitado na maquininha, sem integração com o sistema. Necessário para preparar a NFC-e de cartão.</p>
          </div>}
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" disabled={payments.length >= 10}
        onClick={() => onChange([...payments, { metodo: "dinheiro", valor: "", confirmado: false }])}>Dividir pagamento</Button>
      <div>
        <Label htmlFor="payment-change" className="text-xs">Troco a devolver (somente dinheiro)</Label>
        <Input id="payment-change" inputMode="decimal" value={change || "0"} onChange={e => onChangeChange(e.target.value.replace(",", "."))} />
      </div>
    </fieldset>
  );
}
